import { styled } from '@material-ui/core';

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '2em',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const LeftContainer = styled('div')(({ theme }) => ({
  height: 'fit-content',
  width: '35%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const RightContainer = styled('div')(({ theme }) => ({
  width: '65%',
  display: 'flex',
  flexDirection: 'column',
  gap: '2em',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
